import request from '@/utils/request'

export function getCustomizedList(params) {
  return request({
    url: '/api/A3User/A3User/GetA3UserCustomizedList',
    data: { ...params },
    method: 'post',
    header: {
      'Content-Type': 'application/json;charset=utf-8'  //如果写成contentType会报错
    },

  })
}


export function addOrEditCustomized(params) {
  return request({
    url: '/api/A3User/A3User/CreateOrUpdateA3UserCustomized',
    data: { ...params },
    method: 'post',
    header: {
      'Content-Type': 'application/json;charset=utf-8'  //如果写成contentType会报错
    },

  })
}


export function getA3OrderListByA3UserId(params) {
  return request({
    url: '/api/A3User/A3User/GetA3UserA3OrderListByA3UserId?a3UserId=' + params.a3userId,
    method: 'get',
    header: {
      'Content-Type': 'application/json;charset=utf-8'  //如果写成contentType会报错
    },

  })
}
